import * as i0 from '@angular/core';
import { InjectionToken, NgModule, makeEnvironmentProviders } from '@angular/core';
const defaultModules = {
  toolbar: [['bold', 'italic', 'underline', 'strike'],
  // toggled buttons
  ['blockquote', 'code-block'], [{
    header: 1
  }, {
    header: 2
  }],
  // custom button values
  [{
    list: 'ordered'
  }, {
    list: 'bullet'
  }], [{
    script: 'sub'
  }, {
    script: 'super'
  }],
  // superscript/subscript
  [{
    indent: '-1'
  }, {
    indent: '+1'
  }],
  // outdent/indent
  [{
    direction: 'rtl'
  }],
  // text direction
  [{
    size: ['small', false, 'large', 'huge']
  }],
  // custom dropdown
  [{
    header: [1, 2, 3, 4, 5, 6, false]
  }], [{
    color: []
  }, {
    background: []
  }],
  // dropdown with defaults from theme
  [{
    font: []
  }], [{
    align: []
  }], ['clean'],
  // remove formatting button
  ['link', 'image', 'video'],
  // link and image, video
  ['table']]
};
const QUILL_CONFIG_TOKEN = /*#__PURE__*/new InjectionToken('config', {
  providedIn: 'root',
  factory: () => ({
    modules: defaultModules
  })
});

/**
 * This `NgModule` provides a global Quill config on the root level, e.g., in `AppModule`.
 * But this eliminates the need to import the entire `ngx-quill` library into the main bundle.
 * The `quill-editor` itself may be rendered in any lazy-loaded module, but importing `QuillModule`
 * into the `AppModule` will bundle the `ngx-quill` into the vendor.
 */
let QuillConfigModule = /*#__PURE__*/(() => {
  class QuillConfigModule {
    static forRoot(config) {
      return {
        ngModule: QuillConfigModule,
        providers: [{
          provide: QUILL_CONFIG_TOKEN,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function QuillConfigModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || QuillConfigModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: QuillConfigModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return QuillConfigModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Provides Quill configuration at the root level:
 * ```ts
 * bootstrapApplication(AppComponent, {
 *   providers: [provideQuillConfig(...)]
 * });
 * ```
 */
const provideQuillConfig = config => makeEnvironmentProviders([{
  provide: QUILL_CONFIG_TOKEN,
  useValue: config
}]);

/*
 * Public API Surface of ngx-quill/config
 */

/**
 * Generated bundle index. Do not edit.
 */

export { QUILL_CONFIG_TOKEN, QuillConfigModule, defaultModules, provideQuillConfig };
